export default "__VITE_ASSET__wiwLQcUm__"